import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { DefaultButton } from '@fluentui/react/lib/Button';
import loc from 'owa-localize';
import type { TipsInfo } from '../schema';
import { getIsDarkTheme } from 'owa-fabric-theme';

import * as styles from './styles.scss';

import classNames from 'classnames';

export default observer(function TipsCard({ tipsInfo }: { tipsInfo: TipsInfo }) {
    const onWheel = React.useCallback((ev: React.WheelEvent<HTMLDivElement>) => {
        // prevent canvas from panning
        ev.stopPropagation();
    }, []);

    return (
        <div className={styles.tipsCard} onWheel={onWheel}>
            <img
                className={classNames(
                    styles.illustration,
                    tipsInfo.showImageBackground
                        ? getIsDarkTheme()
                            ? styles.darkIllustrationBackground
                            : styles.lightIllustrationBackground
                        : undefined
                )}
                src={tipsInfo.imagePath}
                aria-hidden={true}
            />
            <div>{loc(tipsInfo.instructionsResourceId)}</div>
            <DefaultButton
                className={styles.SeeFeatureButton}
                text={loc(tipsInfo.buttonTextResourceId)}
                onClick={tipsInfo.teaching}
                ariaLabel={tipsInfo.ariaLabelResourceId}
            />
        </div>
    );
});
